import axios from "axios";
import { getAccessTokenSilently } from "@/auth";

const BASE_URL = "https://billing.clafoutis.eu/api";

export function usePhoneLineService() {

  async function client() {
    const token = await getAccessTokenSilently();
    return axios.create({ baseURL: BASE_URL, headers: { Authorization: `Bearer ${token}` } });
  }

  return {
    async list(params = {}) {
      return (await (await client()).get("/phone-lines", { params })).data;
    },
    async byInvoice(invoiceId) {
      return (await (await client()).get(`/phone-lines/invoice/${invoiceId}`)).data;
    },
    async detect(invoiceId) {
      return (await (await client()).get(`/phone-lines/detect/${invoiceId}`)).data;
    },
    async create(payload) {
      return (await (await client()).post("/phone-lines", payload)).data;
    },
    async update(id, payload) {
      return (await (await client()).patch(`/phone-lines/${id}`, payload)).data;
    },
    async remove(id) {
      return (await (await client()).delete(`/phone-lines/${id}`)).data;
    },
    async linkInvoice(id, invoiceId, autoDetected = false) {
      return (await (await client()).post(`/phone-lines/${id}/invoices`, { invoice_id: invoiceId, auto_detected: autoDetected })).data;
    },
    async unlinkInvoice(id, invoiceId) {
      return (await (await client()).delete(`/phone-lines/${id}/invoices/${invoiceId}`)).data;
    },
    async summary(id, fiscalYearId) {
      return (await (await client()).get(`/phone-lines/${id}/summary`, { params: { fiscal_year_id: fiscalYearId } })).data;
    },
    async listUsers() {
      return (await (await client()).get("/issues/users")).data;
    },
    async listCompanies() {
      const { data } = await (await client()).get("/company");
      return data.companys || [];
    },
    async listFiscalYears() {
      return (await (await client()).get("/fiscalyear")).data;
    },
    async currentUser() {
      return (await (await client()).get("/user")).data;
    },
  };
}
